"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollupAdminLogic__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "blockHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "sendRoot",
                type: "bytes32",
            },
        ],
        name: "NodeConfirmed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "parentNodeHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "nodeHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "executionHash",
                type: "bytes32",
            },
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "beforeState",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "afterState",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "numBlocks",
                        type: "uint64",
                    },
                ],
                indexed: false,
                internalType: "struct Assertion",
                name: "assertion",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "afterInboxBatchAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "wasmModuleRoot",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "inboxMaxCount",
                type: "uint256",
            },
        ],
        name: "NodeCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
        ],
        name: "NodeRejected",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "OwnerFunctionCalled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "challengeIndex",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "address",
                name: "asserter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "challenger",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "challengedNode",
                type: "uint64",
            },
        ],
        name: "RollupChallengeStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "machineHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
        ],
        name: "RollupInitialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "UpgradedSecondary",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "initialBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "finalBalance",
                type: "uint256",
            },
        ],
        name: "UserStakeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "initialBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "finalBalance",
                type: "uint256",
            },
        ],
        name: "UserWithdrawableFundsUpdated",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "_stakerMap",
        outputs: [
            {
                internalType: "uint256",
                name: "amountStaked",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "index",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "latestStakedNode",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "currentChallenge",
                type: "uint64",
            },
            {
                internalType: "bool",
                name: "isStaked",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "amountStaked",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseStake",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bridge",
        outputs: [
            {
                internalType: "contract IBridge",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "challengeManager",
        outputs: [
            {
                internalType: "contract IChallengeManager",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "confirmPeriodBlocks",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "beforeState",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "afterState",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "numBlocks",
                        type: "uint64",
                    },
                ],
                internalType: "struct Assertion",
                name: "assertion",
                type: "tuple",
            },
        ],
        name: "createNitroMigrationGenesis",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "currentChallenge",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "extraChallengeTimeBlocks",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "firstUnresolvedNode",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
            {
                internalType: "bytes32",
                name: "blockHash",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "sendRoot",
                type: "bytes32",
            },
        ],
        name: "forceConfirmNode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "prevNode",
                type: "uint64",
            },
            {
                internalType: "uint256",
                name: "prevNodeInboxMaxCount",
                type: "uint256",
            },
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "beforeState",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "afterState",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "numBlocks",
                        type: "uint64",
                    },
                ],
                internalType: "struct Assertion",
                name: "assertion",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "expectedNodeHash",
                type: "bytes32",
            },
        ],
        name: "forceCreateNode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "staker",
                type: "address[]",
            },
        ],
        name: "forceRefundStaker",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "stakerA",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "stakerB",
                type: "address[]",
            },
        ],
        name: "forceResolveChallenge",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
        ],
        name: "getNode",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "stateHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "challengeHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "confirmData",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "prevNum",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "deadlineBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "noChildConfirmedBeforeBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "stakerCount",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "childStakerCount",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "firstChildBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "latestChildNumber",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "createdAtBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "nodeHash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Node",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
        ],
        name: "getNodeCreationBlockForLogLookup",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "getStaker",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amountStaked",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "index",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "latestStakedNode",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentChallenge",
                        type: "uint64",
                    },
                    {
                        internalType: "bool",
                        name: "isStaked",
                        type: "bool",
                    },
                ],
                internalType: "struct IRollupCore.Staker",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "stakerNum",
                type: "uint64",
            },
        ],
        name: "getStakerAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "inbox",
        outputs: [
            {
                internalType: "contract IInboxBase",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint64",
                        name: "confirmPeriodBlocks",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "extraChallengeTimeBlocks",
                        type: "uint64",
                    },
                    {
                        internalType: "address",
                        name: "stakeToken",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "baseStake",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "wasmModuleRoot",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "loserStakeEscrow",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "chainId",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "chainConfig",
                        type: "string",
                    },
                    {
                        internalType: "uint64",
                        name: "genesisBlockNum",
                        type: "uint64",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "delayBlocks",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "futureBlocks",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "delaySeconds",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "futureSeconds",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct ISequencerInbox.MaxTimeVariation",
                        name: "sequencerInboxMaxTimeVariation",
                        type: "tuple",
                    },
                ],
                internalType: "struct Config",
                name: "config",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "contract IBridge",
                        name: "bridge",
                        type: "address",
                    },
                    {
                        internalType: "contract ISequencerInbox",
                        name: "sequencerInbox",
                        type: "address",
                    },
                    {
                        internalType: "contract IInboxBase",
                        name: "inbox",
                        type: "address",
                    },
                    {
                        internalType: "contract IOutbox",
                        name: "outbox",
                        type: "address",
                    },
                    {
                        internalType: "contract IRollupEventInbox",
                        name: "rollupEventInbox",
                        type: "address",
                    },
                    {
                        internalType: "contract IChallengeManager",
                        name: "challengeManager",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "rollupAdminLogic",
                        type: "address",
                    },
                    {
                        internalType: "contract IRollupUser",
                        name: "rollupUserLogic",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "validatorUtils",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "validatorWalletCreator",
                        type: "address",
                    },
                ],
                internalType: "struct ContractDependencies",
                name: "connectedContracts",
                type: "tuple",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "isStaked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "isStakedOnLatestConfirmed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isValidator",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "isZombie",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastStakeBlock",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "latestConfirmed",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "latestNodeCreated",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "latestStakedNode",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "loserStakeEscrow",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumAssertionPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "nodeHasStaker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "outbox",
        outputs: [
            {
                internalType: "contract IOutbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_outbox",
                type: "address",
            },
        ],
        name: "removeOldOutbox",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "resume",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollupDeploymentBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rollupEventInbox",
        outputs: [
            {
                internalType: "contract IRollupEventInbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sequencerInbox",
        outputs: [
            {
                internalType: "contract ISequencerInbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newBaseStake",
                type: "uint256",
            },
        ],
        name: "setBaseStake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "newConfirmPeriod",
                type: "uint64",
            },
        ],
        name: "setConfirmPeriodBlocks",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_inbox",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_enabled",
                type: "bool",
            },
        ],
        name: "setDelayedInbox",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "newExtraTimeBlocks",
                type: "uint64",
            },
        ],
        name: "setExtraChallengeTimeBlocks",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IInboxBase",
                name: "newInbox",
                type: "address",
            },
        ],
        name: "setInbox",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newLoserStakerEscrow",
                type: "address",
            },
        ],
        name: "setLoserStakeEscrow",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newPeriod",
                type: "uint256",
            },
        ],
        name: "setMinimumAssertionPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IOutbox",
                name: "_outbox",
                type: "address",
            },
        ],
        name: "setOutbox",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "setOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sequencerInbox",
                type: "address",
            },
        ],
        name: "setSequencerInbox",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newStakeToken",
                type: "address",
            },
        ],
        name: "setStakeToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_validator",
                type: "address[]",
            },
            {
                internalType: "bool[]",
                name: "_val",
                type: "bool[]",
            },
        ],
        name: "setValidator",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_validatorWhitelistDisabled",
                type: "bool",
            },
        ],
        name: "setValidatorWhitelistDisabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "newWasmModuleRoot",
                type: "bytes32",
            },
        ],
        name: "setWasmModuleRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stakeToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakerCount",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalWithdrawableFunds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "beacon",
                type: "address",
            },
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeBeacon",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeSecondaryTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeSecondaryToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "validatorUtils",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "validatorWalletCreator",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "validatorWhitelistDisabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wasmModuleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "withdrawableFunds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "zombieNum",
                type: "uint256",
            },
        ],
        name: "zombieAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "zombieCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "zombieNum",
                type: "uint256",
            },
        ],
        name: "zombieLatestStakedNode",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class RollupAdminLogic__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "RollupAdminLogic";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.RollupAdminLogic__factory = RollupAdminLogic__factory;
RollupAdminLogic__factory.bytecode = _bytecode;
RollupAdminLogic__factory.abi = _abi;
